module.exports = __webpack_public_path__ + "img/DSC_0018.4a1f9d78.jpg";